import React from 'react'

import { Typography, Button } from '@telavita-core/react-design-kit'

import ModalGeneric from '../ModalGeneric'

import { ReactComponent as DangerSvg } from 'static/svg/exclamation-icon-variant.svg'

import * as S from './styles'

interface SwitchingConfirmModalProps {
  onClose: () => void
  onConfirm: () => void
  onCancel: () => void
  title: string
  message: string
  onConfirmButtonText: string
  onCancelButtonText: string
}

export function SwitchingConfirmModal({
  onClose,
  onCancel,
  onConfirm,
  title,
  message,
  onCancelButtonText,
  onConfirmButtonText,
}: SwitchingConfirmModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleWrapper>
          <DangerSvg />

          <Typography
            weight='bold'
            center
            variant='content1'
          >
            {title}
          </Typography>
        </S.TitleWrapper>
      }
      onCloseModal={onClose}
    >
      <S.SwitchingConfirmModalContainer>
        <Typography
          variant='content2'
          center
        >
          {message}
        </Typography>

        <S.ButtonsWrapper>
          <Button
            uppercase={false}
            variant='contained'
            onClick={onConfirm}
          >
            {onConfirmButtonText}
          </Button>

          <Button
            uppercase={false}
            variant='outlined'
            onClick={onCancel}
          >
            {onCancelButtonText}
          </Button>
        </S.ButtonsWrapper>
      </S.SwitchingConfirmModalContainer>
    </ModalGeneric>
  )
}